import { NextSeo } from 'next-seo';
import Head from 'next/head';
import React from 'react';

import { WindowDoor } from '@modules/services/WindowDoor/WindowDoor';

const TITLE = 'Expert Window and Door Fitters in London | Qeeper';
const DESC =
  'Expert window and door fitters in London offering repairs, replacements, and uPVC repair services to keep your property secure and visually appealing.';
const URL = 'https://www.qeeper.co.uk/services/window-door';

const SEO_KEYWORDS =
  'door fitters, window and door installation, local doors and windows fittings, upvc door fitting, window fitters london, double glazed window repairs, upvc window repairs';

export const WindowDoorPage = () => {
  return (
    <>
      <Head>
        <meta name="keywords" content={SEO_KEYWORDS} />
        <link rel="canonical" key="canonical" href={URL} />
        <link rel="alternate" hrefLang="en" href={URL} />
      </Head>
      <NextSeo
        title={TITLE}
        description={DESC}
        canonical={URL}
        openGraph={{
          url: URL,
          title: TITLE,
          description: DESC,
        }}
      />
      <WindowDoor />
    </>
  );
};

export default WindowDoorPage;
